import React from 'react';

import { Heading, Text } from '@eluve/components';
import { useTenantIdFromParams } from '@eluve/session-helpers';

import { TenantFeatureFlags } from './components/TenantFeatureFlags';

export const AdminTenantFeatureFlagsPage: React.FC = () => {
  const tenantId = useTenantIdFromParams()!;

  return (
    <div className="grid gap-2">
      <div>
        <Heading size="2xl" weight="semibold">
          Feature Flags
        </Heading>
        <Text>Control which features this organization has access to</Text>
      </div>
      <TenantFeatureFlags tenantId={tenantId} />
    </div>
  );
};
